module.exports = __webpack_public_path__ + "static/media/home-page.081172ce.jpg";